package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SportsAndOutdoorsW500Rounded: ImageVector
    get() {
        if (_sportsAndOutdoorsW500Rounded != null) {
            return _sportsAndOutdoorsW500Rounded!!
        }
        _sportsAndOutdoorsW500Rounded = Builder(name = "SportsAndOutdoorsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(414.48f, 789.13f)
                lineToRelative(11.81f, -55.61f)
                quadToRelative(2.95f, -12.91f, 12.31f, -21.41f)
                reflectiveQuadToRelative(23.16f, -10.5f)
                lineToRelative(123.04f, -9.52f)
                quadToRelative(12.85f, -2.0f, 23.72f, 4.88f)
                reflectiveQuadToRelative(15.81f, 18.64f)
                lineToRelative(15.9f, 38.0f)
                quadToRelative(38.76f, -23.0f, 69.57f, -55.26f)
                quadToRelative(30.81f, -32.26f, 51.57f, -71.78f)
                lineToRelative(-12.0f, -6.24f)
                quadToRelative(-11.0f, -7.53f, -15.88f, -19.15f)
                quadToRelative(-4.88f, -11.61f, -1.9f, -24.45f)
                lineToRelative(27.78f, -120.49f)
                quadToRelative(2.93f, -12.0f, 12.23f, -20.0f)
                quadToRelative(9.29f, -8.0f, 21.29f, -9.97f)
                quadToRelative(-5.0f, -24.55f, -12.37f, -47.89f)
                quadToRelative(-7.36f, -23.34f, -19.15f, -45.18f)
                quadToRelative(-8.76f, 5.0f, -19.26f, 4.38f)
                quadToRelative(-10.5f, -0.62f, -18.5f, -6.38f)
                lineToRelative(-105.28f, -63.53f)
                quadToRelative(-11.0f, -6.76f, -15.76f, -18.88f)
                quadToRelative(-4.77f, -12.12f, -1.77f, -24.85f)
                lineToRelative(8.0f, -33.31f)
                quadToRelative(-30.52f, -14.0f, -63.02f, -20.88f)
                quadToRelative(-32.5f, -6.88f, -66.08f, -6.88f)
                quadToRelative(-13.83f, 0.0f, -28.64f, 1.5f)
                quadToRelative(-14.82f, 1.5f, -28.82f, 4.26f)
                lineToRelative(30.0f, 67.19f)
                quadToRelative(5.0f, 11.85f, 2.5f, 24.85f)
                quadToRelative(-2.5f, 13.0f, -12.5f, 21.0f)
                lineToRelative(-93.28f, 81.29f)
                quadToRelative(-10.0f, 8.76f, -23.38f, 9.88f)
                quadToRelative(-13.38f, 1.12f, -24.38f, -5.88f)
                lineToRelative(-90.57f, -55.29f)
                quadToRelative(-23.0f, 37.76f, -35.38f, 80.55f)
                quadToRelative(-12.38f, 42.78f, -12.38f, 87.54f)
                quadToRelative(0.0f, 16.24f, 3.95f, 51.76f)
                lineToRelative(87.01f, -8.0f)
                quadToRelative(13.84f, -2.0f, 25.34f, 4.38f)
                reflectiveQuadToRelative(16.5f, 19.14f)
                lineToRelative(47.35f, 113.14f)
                quadToRelative(4.94f, 11.91f, 2.56f, 24.67f)
                quadToRelative(-2.38f, 12.76f, -12.33f, 20.71f)
                lineToRelative(-37.82f, 31.81f)
                quadToRelative(26.05f, 19.28f, 56.31f, 32.28f)
                reflectiveQuadToRelative(62.74f, 19.48f)
                close()
                moveTo(485.84f, 618.39f)
                quadToRelative(-12.84f, 1.94f, -23.74f, -4.94f)
                quadToRelative(-10.91f, -6.87f, -15.86f, -18.65f)
                lineToRelative(-53.76f, -122.95f)
                quadToRelative(-5.0f, -11.9f, -1.5f, -24.79f)
                quadToRelative(3.5f, -12.89f, 13.5f, -20.82f)
                lineToRelative(101.04f, -85.28f)
                quadToRelative(9.24f, -8.76f, 22.0f, -9.88f)
                quadToRelative(12.76f, -1.12f, 23.52f, 6.12f)
                lineToRelative(111.13f, 65.35f)
                quadToRelative(10.92f, 6.93f, 16.92f, 18.83f)
                quadToRelative(6.0f, 11.89f, 3.0f, 24.78f)
                lineToRelative(-31.76f, 128.88f)
                quadToRelative(-3.0f, 12.76f, -12.12f, 21.26f)
                quadToRelative(-9.12f, 8.5f, -21.97f, 10.44f)
                lineToRelative(-130.4f, 11.65f)
                close()
                moveTo(479.74f, 888.13f)
                quadToRelative(-84.65f, 0.0f, -158.97f, -32.1f)
                quadToRelative(-74.31f, -32.1f, -129.51f, -87.29f)
                quadToRelative(-55.19f, -55.2f, -87.29f, -129.65f)
                quadToRelative(-32.1f, -74.46f, -32.1f, -159.11f)
                quadToRelative(0.0f, -84.65f, 32.1f, -159.09f)
                quadToRelative(32.1f, -74.43f, 87.29f, -129.63f)
                quadToRelative(55.2f, -55.19f, 129.57f, -87.29f)
                quadToRelative(74.37f, -32.1f, 158.93f, -32.1f)
                quadToRelative(84.65f, 0.0f, 159.1f, 32.1f)
                quadToRelative(74.44f, 32.1f, 129.76f, 87.29f)
                quadToRelative(55.31f, 55.2f, 87.41f, 129.65f)
                quadToRelative(32.1f, 74.46f, 32.1f, 159.11f)
                quadToRelative(0.0f, 84.65f, -32.1f, 159.09f)
                quadToRelative(-32.1f, 74.43f, -87.41f, 129.63f)
                quadToRelative(-55.32f, 55.19f, -129.77f, 87.29f)
                quadToRelative(-74.46f, 32.1f, -159.11f, 32.1f)
                close()
            }
        }
        .build()
        return _sportsAndOutdoorsW500Rounded!!
    }

private var _sportsAndOutdoorsW500Rounded: ImageVector? = null
